import Head from 'next/head'

interface Author {
  name: string
  path: string
}

interface NewsArticleProps {
  title: string
  path?: string
  images: string[] | string
  dateModified?: string
  datePublished?: string
  author?: Author[]
}

export function RichSnippetNewsArticle({
  title,
  path,
  images,
  dateModified,
  datePublished,
  author
}: NewsArticleProps) {
  const schemaNewsArticle = {
    '@context': 'https://schema.org',
    '@type': 'NewsArticle',
    headline: title,
    image: images
  } as any

  if (path) {
    schemaNewsArticle.mainEntityOfPage = {
      '@type': 'WebPage',
      '@id': path
    }
  }

  if (dateModified) {
    schemaNewsArticle.dateModified = dateModified
  }

  if (datePublished) {
    schemaNewsArticle.datePublished = datePublished
  }

  if (author) {
    schemaNewsArticle.author = author.map(author => ({
      '@type': 'Person',
      name: author.name,
      path: author.path
    }))
  }

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(schemaNewsArticle)
        }}
      />
    </Head>
  )
}
